import React, { useEffect, useState, useRef } from 'react';
import "./RecordSearch.scss"

import { useFetching } from '../../../hooks/useFetching';
import PostService from '../../../API/PostService';
import { useSelector } from 'react-redux';

import { Link } from 'react-router-dom';

const RecordSearch = () => {
	const searchRef = useRef()
	const clinic = useSelector(state => state.recordsTable.clinic)

	const [ valueSearch, setValueSearch ] = useState('')
	const [ resultsList, setResultsList ] = useState([])
	const [ open, setOpen ] = useState(false)

	const onChange = (e) => {
		setValueSearch(e.target.value)

		if(e.target.value === ''){
			setOpen(false)
			setResultsList([])
		} else if(e.target.value.length > 2){
			fetchSearchRecords(e.target.value, clinic);
		}
	}

	const [fetchSearchRecords] = useFetching(async (query, clinic) => {
		const response = await PostService.searchRecords(query, clinic)
		if (response.data.success && response.data.result !== false) {
			setResultsList(response.data.result)
			setOpen(true)
		}
	})

	useEffect(() => {
		setTimeout(() => {
			document.addEventListener('click', documentClickHandlerSearch);
		},[0])

		return () => document.removeEventListener('click', documentClickHandlerSearch);
	}, []);

	const documentClickHandlerSearch = (e) => {
		if(!searchRef.current) return;
		if(!searchRef.current.contains(e.target)){
			setOpen(false)
		}
	};

	return (
		<div className="record-search" ref={searchRef}>
			<input type="text"
				value={valueSearch}
				onChange={(e) => onChange(e)}
				onFocus={() => setOpen(true)}
				className={open ? ' open' : ''}
				placeholder='Имя или номер телефона'/>
			{open && resultsList.length > 0 &&
				<div className="record-search__results">
					<div className="record-search__results-inner g-custom-scroll">
						{resultsList && resultsList.length > 0 && resultsList.map((item) => {
							return(
								<Link
								to={'/' + item.id + '/'}>
									<div className="record-search__results-item">
										<div className="record-search__results-item-name">{item.name}&nbsp;{item.last_name}</div>
										<div className="record-search__results-item-date">{item.date_formated}&nbsp;{item.time_formated}</div>
										<div className="record-search__results-item-service">{item.service.short_title}</div>
									</div>
								</Link>
							)
						})}
					</div>
				</div>
			}
		</div>
	);
};

export default RecordSearch;
